import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-arrow-icon',
  imports: [],
  templateUrl: './arrow-icon.component.html',
})
export class ArrowIconComponent {
  @Input() color = 'white';
}
